import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastController } from '@ionic/angular';
import { Plugins,PushNotificationToken,Capacitor } from '@capacitor/core';

const { Device } = Plugins;
const { PushNotifications,PushNotificationToken } = Plugins;

@Component({
  selector: 'app-customer-login',
  templateUrl: './customer-login.page.html',
  styleUrls: ['./customer-login.page.scss'],
})
export class CustomerLoginPage implements OnInit {
  formGroup: FormGroup;
  message = '';
  isLogin = true;
  isConfirmation = false;  
  isConfirmationSend = false;
  device_id: any;
  darkMode = false;

  constructor(
    private _fb: FormBuilder, 
    private router:Router, 
    private authService:AuthService,
    public toastController: ToastController
  ) {
    this.formGroup = this._fb.group({
      username: ['', Validators.compose([Validators.required])],
      password: ['',Validators.compose([Validators.required])],
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  ionViewWillEnter(){
    let isDark = localStorage.getItem('dark_mode');
    console.log("afasdf--"+isDark);
    if(isDark == 'true'){
      console.log("afasdfffffffff--"+isDark);
      localStorage.setItem('dark_mode', 'true');
      this.darkMode = true;
    }else{
      console.log("afasdddddddf--"+isDark);
      localStorage.setItem('dark_mode', 'false');
      this.darkMode = false;
    }
    document.body.classList.toggle('dark', this.darkMode);
  }
  
  ngOnInit() {
    if (Capacitor.platform !== 'web') {
      PushNotifications.requestPermission().then( result => {
        if (result.granted) {
          // Register with Apple / Google to receive push via APNS/FCM
          PushNotifications.register();
        } else {
          // Show some error
        }
      });
      PushNotifications.addListener('registration',
        (token: PushNotificationToken) => {
          console.log(token.value);
          this.getDeviceID(token.value);
        }
      );
    }
  }

  getDeviceID(token){
    this.device_id = token;
    console.log(token);
  }

  async onLogin(){
    const info = Device.getInfo();
    let user={
      platform: (await info).platform,
      device_id: this.device_id,
      username: this.formGroup.get('username').value.trim(),
      password: this.formGroup.get('password').value.trim()
    }
    this.authService.login(user).subscribe(
      response => {
        if (response.token != '' && response.token !== undefined) {
          this.formGroup.reset();
          localStorage.setItem('auth_token', response.token);
          localStorage.setItem('first_name', response.first_name);
          localStorage.setItem('last_name', response.last_name);
          this.router.navigate(['dashboard']);
        }else if(response.status == 200){
          this.message = response.message;
          this.isLogin = false;
          this.isConfirmation = true;
          this.isConfirmationSend = false;
        } else {
          this.presentToast(response.error.error.message);
          this.isLogin = true;
          this.isConfirmation = false;
          this.isConfirmationSend = false;
        }
      },
      error => {
        this.presentToast(error.error.error.message);
      }
    );    
  }

  
  
  resendConfirmation(){
    let user={
      username: this.formGroup.get('username').value
    }

    this.authService.reSendConfrimation(user).subscribe( 
      response => {
        this.message = response.message;
        this.isLogin = false;
        this.isConfirmation = false;  
        this.isConfirmationSend = true;
      },
      error => {
        this.message = error.error.message;
        this.isLogin = false;
        this.isConfirmation = true;  
        this.isConfirmationSend = false;
      }
    ); 
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

  onRegister(){
    this.router.navigate(['customer-register']);
  }

  onForgotPassword(){
    this.router.navigate(['customer-forgot-password']);
  }
  
  
  changeDarkMode(event){
    if (event.detail.checked) {
      localStorage.setItem('dark_mode', 'true');
      this.darkMode = true;
    }else{
      localStorage.setItem('dark_mode', 'false');
      this.darkMode = false;
    }
    document.body.classList.toggle('dark', this.darkMode);
    console.log("dark_mode_toggle_value-"+this.darkMode);
  }


  loginForm(){
    this.formGroup.reset();
    this.message = '';
    this.isLogin = true;
    this.isConfirmation = false;  
    this.isConfirmationSend = false;
  }

  backPage(){
    this.router.navigate(['home']);
  }

  backHome(){
    this.router.navigate(['home']);
  }

}
